import { Reveal, ChapterHeading } from "./Reveal";

const About = () => (
    <section
        id="about"
        data-testid="about-section"
        className="bg-white py-20 sm:py-28 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
                <div>
                    <ChapterHeading
                        testId="about-heading"
                        chapter="04"
                        eyebrow="About Me"
                        title="Hi, I'm Charlie Schmidt."
                    />
                    <Reveal delay={0.2}>
                        <div className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
                            <p>
                                I'm a freelance web designer and developer, and
                                CS Studio is my one-person studio. I started it
                                because I kept seeing great businesses let down
                                by websites that didn't do them justice: dated,
                                slow, or built from the same template as
                                everyone else's.
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <div
                            data-testid="about-advantage-card"
                            className="mt-10 rounded-2xl border border-brand/20 bg-ice p-6 sm:p-8"
                        >
                            <p className="text-sm font-semibold text-ink">
                                A new studio, and that's your advantage
                            </p>
                            <ul className="mt-4 space-y-3">
                                {[
                                    "My full attention. You're never one of twenty clients",
                                    "Lower introductory pricing while I build my portfolio",
                                    "A direct line to the person doing the work, always",
                                ].map((point) => (
                                    <li
                                        key={point}
                                        className="flex items-start gap-2.5 text-sm text-slate-600"
                                    >
                                        <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
                                        {point}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);

export default About;
